import { render, staticRenderFns } from "./RecomendedList.vue?vue&type=template&id=2be2b35a&scoped=true&"
import script from "./RecomendedList.vue?vue&type=script&lang=js&"
export * from "./RecomendedList.vue?vue&type=script&lang=js&"
import style0 from "./RecomendedList.vue?vue&type=style&index=0&id=2be2b35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2b35a",
  null
  
)

export default component.exports